import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISelectOptionGroup } from 'projects/bis-shared/src/lib/dynamic-forms/models/select-option-group';
import { map } from 'rxjs/operators';
import { SelectHelpers } from 'projects/bis-shared/src/lib/utility/select-helpers';
import { WorkAssignee } from './work-assignee';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';



@Injectable()
export class BulkEditObjectService {
  constructor(private http: HttpClient, private externalApiUrls: ExternalApiUrls) {}

  getAssignees(workGroupId: number): Observable<ISelectOptionGroup[]> {
    return this.http.get<WorkAssignee[]>(this.externalApiUrls.workGroup.getSystemUsers(workGroupId)).pipe(
      map(forms =>
        SelectHelpers.toSelectList(
          forms,
          c => c.name,
          c => c.id,
        ),
      ),
    );
  }

}
